import { call, put, takeEvery } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import {
  SETTING_LIST_REQUESTING,
  SETTING_LIST_API,
  SETTING_UPDATE_STORE_REQUESTING,
  SETTING_UPDATE_STORE_API
} from './constants'

import {
  settingListSuccess,
  settingListError,
  settingUpdateStoreError,
  settingUpdateStoreSuccess
} from './actions'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi (formData) {
  const request = axiosApi().post(
    SETTING_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function updateStoreRequestApi(formData) {
  const request = axiosApi().post(
    SETTING_UPDATE_STORE_API,
    formData
  )
  return handleRequest(request);
}

function* settingUpdateStoreFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(updateStoreRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(settingUpdateStoreSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(settingUpdateStoreError(error))
  }
}
function* settingListRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(settingListSuccess(results.data))

  } catch (error) {
    yield put(settingListError(error))
  }
}

function* settingWatcher () {
  yield [
    takeEvery(SETTING_LIST_REQUESTING, settingListRequestFlow),
    takeEvery(SETTING_UPDATE_STORE_REQUESTING, settingUpdateStoreFlow),
  ]
}

export default settingWatcher



// WEBPACK FOOTER //
// ./src/views/Setting/sagas.js